/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from "../../../../locale/useTranslation";
import { ENTITYNAME } from '../../../constant/constant';
import { OttPosterCollectionSelectionColumns } from '../../../utility/customColumns';
import CollectionSelection from '../../CollectionSelection';

const validateFileType = (e, setImage, name) => {

  let fileName = e.target.value;
  let idxDot = fileName.lastIndexOf(".") + 1;
  let extFile = fileName.substring(idxDot, fileName.length).toLowerCase();
  if (extFile === "jpg" || extFile === "jpeg" || extFile === "png") {
    setImage((old) => {
      return old.add({ name: name, data: e.target.files[0] })
    })
    e.target.setCustomValidity("")
  } else {
    e.target.setCustomValidity("Only .jpg/.jpeg or .png files are allowed!")
  }
}

export const ImageBrowser = (props) => {
  const lang = useTranslation();
  const hidePosterLibrary = props.hidePosterLibrary ?? false;
  const showBrowseButton = props.showBrowseButton ?? true;
  const name = props.name;

  const [value, _setValue] = useState("");
  const [openImageBank, setOpenImageBank] = useState(false);

  const setValue = (data) => {
    _setValue(data);
  };

  useEffect(() => {
    setValue(props.value || "");
  }, [props.value]);

  const onChange = (e) => {
    if (e.target?.files?.[0]) {
      const file = e.target.files[0];
      const previewUrl = URL.createObjectURL(file);
      setValue(previewUrl);

      if (typeof props.setSelectedImage === "function") {
        props.setSelectedImage([{ ImageUrl: previewUrl, file }]);
      }

      props.onChange?.({
        target: { name, type: "file", value: previewUrl, files: [file] },
      });
    } else {
      const inputValue = e.target?.value || "";
      setValue(inputValue);

      if (typeof props.setSelectedImage === "function") {
        props.setSelectedImage([{ ImageUrl: inputValue }]);
      }

      props.onChange?.({
        target: { name, type: "text", value: inputValue },
      });
    }
  };

  const handleImageSelect = (dataList) => {
    const imageUrl = dataList[0]?.ImageUrl || "";
    setValue(imageUrl);

    if (typeof props.setSelectedImage === "function") {
      props.setSelectedImage(dataList);
    }

    props.onChange?.({
      target: { name, type: "text", value: imageUrl },
    });
  };

  return (
    <>
      <div className="input-group">
        <input
          name={name}
          className="form-control form-control-sm"
          type="text"
          placeholder="Paste image URL or select a file..."
          value={value}
          onChange={onChange}
        />

        {!hidePosterLibrary && (
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
            style={{ height: "32px", margin: "0 0 0 3px" }}
            onClick={() => setOpenImageBank(true)}
          >
            <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
        )}

        {showBrowseButton && (
          <button
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary"
            style={{ padding: "0px", height: "32px", margin: "0 0 0 3px", width: "31px" }}
          >
            <label
              className="fa-solid fa-search"
              style={{ margin: "0", cursor: "pointer" }}
            >
              <input
                name={name}
                type="file"
                // Removed accept="image/*" so all image formats are allowed (gif, svg, etc.)
                hidden
                onChange={onChange}
              />
            </label>
          </button>
        )}
      </div>

      <p className="text-muted" style={{ fontSize: "10px", margin: 0 }}>
        {props?.note ?? lang.poster_note_image_size_label}
      </p>

      {openImageBank && (
        <CollectionSelection
          entityname={props?.entityName ?? ENTITYNAME.OttPosters}
          customColumns={OttPosterCollectionSelectionColumns}
          title={lang.select_url_tooltip}
          closeForm={() => setOpenImageBank(false)}
          wherestatement={props.wherestatement ?? ""}
          setDataList={handleImageSelect}
          mode="single"
          width="50vw"
        />
      )}
    </>
  );
};


